import { type HeadersParams } from "./types";

export async function makeHeaders(params: HeadersParams) {
  const auth0Token = await params.getTokenSilently();
  const headers: Record<string, string> = {
    "content-type": "application/json",
    authorization: `Bearer ${auth0Token}`,
  };
  if (params.impersonateUserId) {
    headers["X-NB-Impersonate-User"] = params.impersonateUserId;
  }
  if (params.actingUserId) {
    headers["X-NB-Acting-User"] = params.actingUserId;
  }
  if (params.useDevelopmentAnalyticsData) {
    headers["x-use-development-analytics-data"] = "true";
    if (params.customBqDataset) {
      headers["x-custom-bq-dataset"] = params.customBqDataset;
    }
  }
  if (params.isDemoMode) {
    headers["x-anonymize-data"] = "true";
  }

  return headers;
}
